import { API, graphqlOperation, Storage, Auth } from 'aws-amplify';

export default {
    namespaced:true,
    state: {
        key: null,
        domain: null,
        stats: null,
        uploadProgress: 0,
        job: null,
        type: null
    },
    mutations: {
        key: (state, payload) => { state.key = payload.value },
        domain: (state, payload) => { state.domain = payload.value },
        stats: (state, payload) => { state.stats = payload.value },
        uploadProgress: (state, payload) => { state.uploadProgress = payload.value },
        job: (state, payload) => { state.job = payload.value },
        type: (state, payload) => { state.type = payload.value}
    },
    getters: {
       
    },
    actions: {
        async uploadFile(context, payload) {
            // todo get filename?
            context.commit('domain', { value: payload.domain });
            var s3result = await Storage.put(`${payload.type}/${payload.domain}/${Date.now()}.csv`, payload.file, {
                level: 'private',
                contentType: payload.mime,
                progressCallback(progress) {
                    console.debug(`Uploaded: ${progress.loaded}/${progress.total}`);
                    context.commit('uploadProgress', { value: Math.max(95, progress.loaded/(progress.total / 100))});
                },
            });
            //console.dir(s3result);
            const credentials = await Auth.currentUserCredentials();
            //console.dir(credentials);
            // the files are saved to dirs for each user
            // https://docs.amplify.aws/lib/storage/configureaccess/q/platform/js
            let key = `private/${credentials.identityId}/${s3result.key}`;
            context.commit('key', { value: { full: key, original: s3result.key } });
            context.commit('type', { value: payload.type });
            if(payload.type == 'contacts' || payload.type == 'delete') {
                const gqresult = await API.graphql(graphqlOperation(`
                query AnalyzeFile($input: ImportJobInput!) {
                    analyzeCustomerImportFile(input: $input) {
                        rows
                        emails
                        file
                    }
                }
            `, { input: { domainID: payload.domain, key}}));
            context.commit('stats', { value: gqresult.data.analyzeCustomerImportFile });
            } else if(payload.type == 'orders') {
                const gqresult = await API.graphql(graphqlOperation(`
                query AnalyzeFile($input: ImportJobInput!) {
                    analyzeOrderImportFile(input: $input) {
                        orders
                        total
                        emails
                        from
                        to
                        file
                    }
                }
            `, { input: { domainID: payload.domain, key}}));
            context.commit('stats', { value: gqresult.data.analyzeOrderImportFile });
            } 
            
            context.commit('uploadProgress', { value: 100 });
            
            return true;
        },

        async createJob(context, payload) {
            let q = 'createCustomerImportJob';
            if(context.state.type == 'orders') {
                q = 'createOrderImportJob';
            }
            if(context.state.type =='delete') {
                q = 'createCustomerDeletionJob';
            }
            const result = await API.graphql(graphqlOperation(`
            mutation CreateJob($input: ImportJobInput!) {
                ${q}(input: $input) {
                    progress
                    timestamp
                    data
                    result
                }
              }
            `, { input: { domainID: context.state.domain, key: context.state.key.full, file: context.state.stats.file, tags: payload.tags/*?.map(t => t.id)*/, config: JSON.stringify(payload.config) }}));
            let job = result.data[q];
            if(job.data) {
                job.data = JSON.parse(job.data);
            }
            context.commit('job', { value: job });
            return context.state.job;
        },

        async updateJob(context) {
            const result = await API.graphql(graphqlOperation(`
            query GetJob($id: ID!) {
                getDomain(id: $id) {
                  jobStatus {
                    progress
                    timestamp
                    data
                    result 
                  }
                }
              }
            `, { id: context.state.domain }));
            let job = result.data.getDomain.jobStatus;
            if(job.data) {
                job.data = JSON.parse(job.data);
            }
            context.commit('job', { value: job });
            return context.state.job;
        },

        async reset(context) {
            context.commit('domain', {value: null});
            context.commit('stats', {value: null});
            context.commit('job', {value: null});
            context.commit('uploadProgress', {value: 0});
            if(context.state.key) {
                await Storage.remove(context.state.key.original, { level: 'private' });
            }
            context.commit('key', {value: null});
        },

        async unsubscribe(context, payload) {
            const result = await API.graphql(graphqlOperation(`
            mutation ($domainId: ID! , $email: String!) {
                deleteCustomer(input: {domainID: $domainId, email: $email})
              }
              
            `, payload ));
            return result.data.deleteCustomer;
        }
    }
}